// The currency this person's expenses default to (expense-currency.js defaultCurrencyFor):
// their users record's office against settings.offices — India → INR. The session does
// not carry the office, so the users list is read once and the answer kept.
import { allUsers, getFxRate } from './db.js';
import { orgSetting } from './org.js';
import { defaultCurrencyFor, userRecordFor, mileageAllowedFor, fxOf, GBP } from './expense-currency.js';

let cached = null; let cachedFor = null; let usersP = null; let usersFor = null;
const myRecord = (session) => {
  const key = String((session && (session.email || session.uid)) || '');
  if (!usersP || usersFor !== key) { usersFor = key; usersP = allUsers().then((users) => userRecordFor(users, session)); }
  return usersP;
};
/** → Promise<'GBP' | 'INR'>. Never throws: anything unreadable is GBP, as every claim before this. */
export function myDefaultCurrency(session) {
  const key = String((session && (session.email || session.uid)) || '');
  if (cached && cachedFor === key) return cached;
  cachedFor = key;
  cached = myRecord(session)
    .then((me) => defaultCurrencyFor(me, orgSetting('offices', [])))
    .catch(() => GBP);
  return cached;
}

/**
 * → Promise<boolean>: may this person claim mileage? (Karan 01/11/2026: "Turn off India staff's
 * ability to claim mileage for now.") The India office only when settings.money.indiaMileage is
 * true. Unreadable → true (UK staff unchanged; the rules and the server still refuse India).
 */
export function myMileageAllowed(session) {
  return myRecord(session)
    .then((me) => mileageAllowedFor(me, orgSetting('offices', []), orgSetting('money', null)))
    .catch(() => true);
}

let fxP = null;
/** → Promise<{ rate, at } | null>: the indicative INR→GBP rate, read once a session; null = show no £. */
export function myFxRate() {
  if (!fxP) fxP = getFxRate().then(fxOf).catch(() => null);
  return fxP;
}
